import { useCallback } from 'react';
import {
	useFirstTimeMigratedUserFetchUserLazyQuery,
	useFirstTimeMigratedUserUpdateUserMutation,
} from './graphql.generated';

export const useMigratedUserIsLoggingInForTheFirstTime = () => {
	const [fetchUser] = useFirstTimeMigratedUserFetchUserLazyQuery();
	const [updateUser] = useFirstTimeMigratedUserUpdateUserMutation();

	const checkMigratedUserIsLoggingInForTheFirstTime = useCallback(async () => {
		try {
			const result = await fetchUser();
			if (
				result.data?.currentUser?.id &&
				!result.data?.currentUser?.hasLoggedIn &&
				result.data?.currentUser?.migrationAccountUuid
			) {
				await updateUser({
					variables: { input: { id: result.data?.currentUser?.id, hasLoggedIn: true } },
				});
				return true;
			}
		} catch (error) {
			console.error(error);
		}

		return false;
	}, [fetchUser, updateUser]);

	return {
		checkMigratedUserIsLoggingInForTheFirstTime,
	};
};
